import styled from 'styled-components';

export const DefaultZoom = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color:transparent;
  height: 35px;
  color: white;
  width: 35px;
  border-radius: 5px;
  border: 2px solid transparent;
  cursor: pointer;
  &:hover{
    background-color: rgb(0 0 0 / 95%);    
  }
`;

export const Container = styled.div`
  .ant-slider {
    min-width: 100px;
    display: inline-block;
    margin:0 !important;
    margin-right:20px !important;
    
    .ant-slider-track {
      background-color:  rgb(255 255 255 / 90%);    
      position: absolute;
      height: 4px;
      top: 4px;
      z-index: 2;
    }
    
    .ant-slider-handle {
      border-color: rgb(255 255 255 / 90%);
      
      &:focus {
        box-shadow: 0 0 0 5px rgb(255 255 255 / 10%);
      }
    }
    .ant-slider-step{
      background:rgb(253 174 17) !important;
    }
    &:hover {
      .ant-slider-track {
        background-color:  rgb(255 255 255 / 90%);
      }

      .ant-slider-handle, .ant-slider-handle.ant-slider-handle, .ant-slider-handle:not(.ant-tooltip-open) {
        border-color:  rgb(255 255 255 / 90%);
      }
    }
  }
  .ant-tooltip-open {
    .ant-slider-track {
      background-color:  rgb(255 255 255 / 90%);
    }
  }
  .ant-select-arrow {
    right: 0px;
    margin-top: -7px;

    .ant-select-arrow-icon {
      color: #fff;
      font-size: 14px;
      margin-right: 5px;
    }
  }
  .ant-select-selection-selected-value {
    font-size: 14px;
    font-weight: 600;
    color: #fff;
  }
  
 .ant-select-selection {
    background-color: transparent;
    border: 2px solid transparent;
    min-width: 81px;
    height: 35px;
    display: flex;
    align-items: center;
    &:hover, &:focus {
      background-color: rgb(0 0 0 / 95%);
      border-color: transparent;
    }
  }
  @media only screen and (min-width: 1450px) {
    .ant-select-selection {
      height: 45px !important;
      min-width: 120px !important;
    }  
    .ant-select-selection-selected-value {
      font-size: 18px !important;
      padding-top: 4px !important;
    }
    .ant-select-arrow {
      right: 0px;
      margin-top: -12px;
    }
  }
`;
